import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { HashStorageService } from '@df/browser/storage/hash-storage.service';
import { GiftcardsCategoryViewComponentDef } from '@df/module-giftcards/giftcards-category-view.component.def';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { StickyFreeComponent } from '../../common/sticky-free/sticky-free.component';
import { GiftcardsProductComponent } from './giftcards-product.component';

@Component({
    selector: 'giftcards-category-view',
    templateUrl: './giftcards-category-view.html',
    styles: [
        `
            :host {
                sticky-free {
                    --sticky-shift: var(--element-height-page-header, 0px);
                }
            }
        `
    ],
    standalone: true,
    imports: [CommonModule, GiftcardsProductComponent, GridModule, StickyFreeComponent, TranslatePipe]
})
export class GiftcardsCategoryViewComponent extends GiftcardsCategoryViewComponentDef {
    protected hashStorageService = inject(HashStorageService);

    handleSelectNext(): void {
        const models = this.listing?.getSourceModels() || [];

        this.selectGiftcard(models[1]?.id);
    }

    protected override onModelChange(): void {
        super.onModelChange();

        if (this.listing) {
            const models = this.listing.getSourceModels();

            if (models?.length) {
                this.selectGiftcard(models[0].id);
            }

            if (this.hashStorageService.get('standardGiftCard')) {
                this.selectGiftcard(models[1]?.id);
            }
        }
    }
}
